import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { WorkGridItemObject, WorkObject } from '@it2go/types';
import {
    WorkDataContinuousRecordObject
} from '@libs/types/src/services/object-type/work/work-data-continuous-record.object';

@Injectable()
export class FolderContinuousRecordWidgetStore extends ComponentStoreV2Factory {

    public lastRecord = computed<WorkGridItemObject<WorkDataContinuousRecordObject> | null>(() => this.data.getWorks()?.items?.[0] || null);

    public lastWorkData = computed(() => {
        return this.lastRecord()?.workData?.data || '';
    });

}
